import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import signUpLayer from "../../assets/sign_up_layer.png";
import Loader from "../../components/Loader";
import { sendForgotPasswordOtp } from "../../api/auth"; // 👈 api call

// ✅ Validation Schema
const schema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
});

type FormData = {
  email: string;
};

const ForgotPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm<FormData>({
    resolver: yupResolver(schema),
  });

  const navigate = useNavigate();

  const onSubmit = async (data: FormData) => {
    try {
      const response = await sendForgotPasswordOtp(data);
      localStorage.setItem("email", data.email);
      toast.success("OTP sent successfully!");
      navigate("/verify-otp");
      reset();
      console.log("API Response:", response.data);
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-center bg-cover p-6"
      style={{ backgroundImage: `url(${signUpLayer})` }}
    >
      <ToastContainer position="top-right" autoClose={3000} />
      {/* ✅ Logo above card */}
      <div className="flex justify-center mb-3">
        <img src={logo} alt="Orthodontic Logo" className="h-24 w-auto object-contain" />
      </div>
      <div className="bg-white w-full max-w-md rounded-2xl shadow-lg p-6">

        <h2 className="brand-heading text-center mb-6">Forgot Password</h2>
        {isSubmitting && <Loader />}

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          {/* Email */}
          <div>
            <label className="block text-sm font-medium">Email</label>
            <input
              type="email"
              {...register("email")}
              placeholder="Enter your email"
              className="mt-1 w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">
                {errors.email.message}
              </p>
            )}
          </div>

          {/* Send OTP Button */}
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-[#016683] text-white py-2 rounded-lg hover:opacity-90 transition disabled:opacity-50"
          >
            {isSubmitting ? "Sending..." : "Send OTP"}
          </button>
        </form>

        {/* Back to Login link */}
        <p className="text-sm text-center mt-4">
          Back to{" "}
          <Link to="/login" className="text-blue-600 hover:underline">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
